import { Component, OnInit } from '@angular/core';
import { WordpressService } from '../../../services/wordpress.service';
import { OnSetMomentCard } from '../../../models/service.model';

@Component({
  selector: 'app-behind-the-scenes',
  templateUrl: './behind-the-scenes.component.html',
  styleUrls: ['./behind-the-scenes.component.scss']
})
export class BehindTheScenesComponent implements OnInit {
  onSetMoments: OnSetMomentCard[] = [];
  onSetMomentsLoading = true;
  onSetMomentsError: string | null = null;
  onSetMomentsSkeletonItems = Array.from({ length: 6 });

  constructor(private wordpressService: WordpressService) { }

  ngOnInit(): void {
    this.loadOnSetMoments();
  }

  private loadOnSetMoments(): void {
    this.wordpressService.getOnSetMoments().subscribe({
      next: items => {
        this.onSetMoments = items;
        this.onSetMomentsLoading = false;
      },
      error: err => {
        this.onSetMomentsError = this.formatError(err);
        this.onSetMomentsLoading = false;
      }
    });
  }

  trackByOnSetMoment(index: number, item: OnSetMomentCard): number {
    return item.id;
  }

  private formatError(err: any): string {
    if (err?.status) {
      return `${err.status} ${err.statusText || 'Error'}${err.error?.message ? ' - ' + err.error.message : ''}`;
    }

    return err?.message || 'Unable to fetch on set moments from WordPress.';
  }

}
